import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { allowedTenantIds } from "../../config/tenantConfig";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();

  const account = accounts[0];
  const tenantId = account?.idTokenClaims?.tid;

  useEffect(() => {

    if (tenantId && !allowedTenantIds.includes(tenantId)) {
      instance.logoutRedirect();
    }
  }, [tenantId, instance]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!tenantId || !allowedTenantIds.includes(tenantId)) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
